'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

exports.default = function (context) {
  return {
    context: context,
    message: _constants.errors.URL_NO_SUPPORT,
    hint: _constants.hints.URL_NO_SUPPORT
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplayer/lib/util/errorHandlers/urlNotSupportedError.js
// module id = 789
// module chunks = 0